export default __webpack_public_path__ + "static/media/18835062-8aa7-4588-96ed-7f0f93da99a7.106534e0.jpg";